import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { CoreGoogleDevice } from '../../../models/CoreDeviceModels';
import { RequestState } from '../../../models/RequestState';
import { RootState } from '../../../store/store';
import StatusCode from '../../../util/StatusCode';
import * as Helper from '../../../util/Helper';
import TableHorizontal, { InfoObject } from '../../misc/TableHorizontal';

const DeviceViewUsers = () => {
    const { t } = useTranslation(['device', 'common']);
    const device = useSelector<RootState, RequestState<CoreGoogleDevice>>(state => state.device.googleDevice);

    const mapUsers = (): InfoObject[] => {
        if (device.code !== StatusCode.COMPLETE) {
            return [];
        }

        return (device.data.users ?? []).map((user) => ({
            id: user.userId,
            data: [
                { value: <Link to={`/user/${user.userId}/information`}>{user.userDisplayName ?? user.userId}</Link> },
                { value: Helper.active(user.active) },
                { value: Helper.formatDateOnly(user.created) },
                { value: Helper.formatDateOnly(user.removed) },
            ]
        }));
    }

    return (
        <TableHorizontal
            header={[
                { value: t('googleDeviceListing.connectedUsersTableHeaders.connectedUser', { ns: 'device' }) },
                { value: t('googleDeviceListing.connectedUsersTableHeaders.connectionActive', { ns: 'device' }) },
                { value: t('googleDeviceListing.connectedUsersTableHeaders.connectionCreated', { ns: 'device' }) },
                { value: t('googleDeviceListing.connectedUsersTableHeaders.connectionRemoved', { ns: 'device' }) },
            ]}
            info={mapUsers()}
            error={device.code === StatusCode.ERROR}
            searching={device.code === StatusCode.PENDING}
            noResMsg={t('device.notFoundUsers', { ns: 'device' })}
        />
    );
}

export default DeviceViewUsers;
